window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    // jQuery
    window.$ = window.jQuery = require('jquery');
    // require('jquery-ui');

    // Popper
    window.Popper = require('popper.js').default;

    // Bootstrap
    window.Bootstrap = require('bootstrap');
} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Custom components
window.Fnc = require('./components/functions');
window.Init = require('./components/init');
window.Listing = require('./components/listing');
window.NestableComp = require('./components/nestable');
window.Validator = require('./components/validate');
window.CustomModal = require('./components/modal');

// Validation
require('jquery-validation');
require('./locales/lt_locale_validate');

// Select2
require('select2');
require('./locales/lt_locale_select2');

// PNotify
window.PNotifyFontAwesome4 = require('@pnotify/font-awesome4');
window.Pnotify = require('@pnotify/core');

Pnotify.defaultModules.set(PNotifyFontAwesome4, {});

// Nestable
window.Nestable = require('nestable2');

// Scrollbar
require('jquery.scrollbar');

// Moment
window.Moment = require('moment');
require('./locales/lt_locale_moment');
require('./locales/en_locale_moment');

// PDF js
const PDFjsWorker = require('pdfjs-dist/build/pdf.worker.entry');
window.PDFjs = require('pdfjs-dist');
PDFjs.GlobalWorkerOptions.workerSrc = PDFjsWorker;

// Air Datepicker
window.AirDatepicker = require('air-datepicker/air-datepicker');
import airDatePickerLocale from './locales/lt_locale_air-datepicker'; //works only with import
AirDatepicker.defaults.locale = airDatePickerLocale;
